import { CopyParagraph } from '@sleepstation/components-copy'
import { HLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import {
  baseline,
  color,
  paddingTop,
  themeFontMonospace,
  top,
} from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({ spacing: LAYOUT_SPACING.LARGE })``

const Timecode = styled.div`
  ${baseline(-2)}
  ${themeFontMonospace(`bold`)}
  ${color(`bodySecondary`)}
  ${paddingTop(0.175)}
  position: relative;
  ${top(0.05)}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TranscriptionItem = ({ timecode, body }) => (
  <Layout>
    <Timecode>{timecode}</Timecode>
    <CopyParagraph>{body}</CopyParagraph>
  </Layout>
)

TranscriptionItem.propTypes = {
  timecode: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
}

export default TranscriptionItem
